import React from 'react';
import './Awards.css';

const AWARDS = [
  {
    title: 'StartupTN Tanseed 5.0',
    desc: 'Secured a government grant from StartupTN under the Tanseed 5.0 programme — recognising ibots as a high-potential innovation-driven startup in Tamil Nadu.',
    organiser: 'StartupTN · Government of Tamil Nadu',
    category: 'Grant',
    year: '2024',
  },
  {
    title: 'Digital Women Awards 2023',
    desc: 'Winner of the Digital Women Awards 2023, celebrating women entrepreneurs driving digital innovation and technology impact across India.',
    organiser: 'SheThePeople',
    category: 'National Award',
    year: '2023',
  },
  {
    title: 'Wonder Women Award 2024',
    desc: 'Recipient of the Wonder Women Award 2024, honouring outstanding women leaders making a difference in education, entrepreneurship and technology.',
    organiser: 'Parivu TV',
    category: 'Leadership Award',
    year: '2024',
  },
  {
    title: 'EDII – IVP B Voucher Fund',
    desc: 'Awarded the IVP B Voucher Fund by EDII (Entrepreneurship Development Institute of India), supporting ibots in scaling its innovation and product development.',
    organiser: 'EDII — Entrepreneurship Development Institute of India',
    category: 'Fund',
    year: '2024',
  },
];

const TrophyIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#f5c518" strokeWidth="1.8">
    <path d="M6 9H4.5a2.5 2.5 0 0 0 0 5H6"/>
    <path d="M18 9h1.5a2.5 2.5 0 0 1 0 5H18"/>
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/>
    <path d="M12 15v3"/>
    <path d="M8 21h8"/>
  </svg>
);

const StarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="#f5c518" stroke="#f5c518" strokeWidth="1">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

function Awards() {
  return (
    <section className="aw__section">

      {/* Header */}
      <div className="aw__header">
        <p className="aw__eyebrow">Recognition & Honours</p>
        <h2 className="aw__title">Awards & Achievements</h2>
        <p className="aw__sub">
          ibots has been nationally recognised for innovation, women entrepreneurship,
          and contribution to STEM education in India.
        </p>
      </div>

      {/* Cards */}
      <div className="aw__grid">
        {AWARDS.map((a, i) => (
          <div key={i} className="aw__card">

            {/* Glow number */}
            <div className="aw__card-num">0{i + 1}</div>

            {/* Top row */}
            <div className="aw__card-top">
              <div className="aw__icon-wrap">
                <TrophyIcon />
              </div>
              <div className="aw__card-meta">
                <span className="aw__category">{a.category}</span>
                <span className="aw__year">{a.year}</span>
              </div>
            </div>

            {/* Title */}
            <h3 className="aw__card-title">{a.title}</h3>

            {/* Description */}
            <p className="aw__card-desc">{a.desc}</p>

            {/* Organiser */}
            <div className="aw__organiser">
              <StarIcon />
              <span>{a.organiser}</span>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
}

export default Awards;
